export let attachmentPolicyHyperLinkText = "YsE6wb";
export let attachmentPolicyInformationReadOnly = "PyUube";
export default {attachmentPolicyHyperLinkText,attachmentPolicyInformationReadOnly};